<template>
  <div class="el-Require">
    <el-row class="page_content">
      <h1 class="head_title">{{$getShowName()}}写作</h1>
      <div class="nopermission" style="font-size: 18px;"  v-if="!(permission)">你没有提交论文权限</div>
      <div class="permission" v-if="permission">
        <div class="spin-container">
          <div class="ant-steps">
            <div class="ant-steps-item" v-for="(item, index) in stepGroup" :class="{
              'finish': item.active == 1 ? true : false
            }" @click="change(item.tag)">
              <div class="ant-steps-item-container">
                <div class="ant-steps-item-tail">
                </div>
                <div class="ant-steps-item-icon">
                  <div class="sbox">
                    <span class="icon1" style="display:none;"></span>
                    <span class="icon2">{{ index + 1 }}</span>
                  </div>
                </div>
                <div class="ant-steps-item-content">
                  {{ item.lable }}
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="tabbox">
          <div v-if="active == 'topicchoice'">
            <topicchoice></topicchoice>
          </div>
          <div v-if="active == 'proposal'">
            <proposal></proposal>
          </div>
          <div v-if="active == 'draft'">
            <draft></draft>
          </div>
          <div v-if="active == 'final'">
            <final></final>
          </div>
          <div v-if="active == 'finalscore'">
            <finalscore></finalscore>
          </div>
          <div v-if="active == 'reply'">
            <reply></reply>
          </div>
          <div v-if="active == 'complete'">
            <complete></complete>
          </div>
          <div v-if="active == 'bindingMaterial'">
            <bindingMaterial></bindingMaterial>
          </div>
        </div>
      </div>
        
    </el-row>
  </div>
</template>
<script>
import topicchoice from './writeGroup/topicchoice.vue'
import proposal from './writeGroup/proposal.vue'
import draft from './writeGroup/draft.vue'
import final from './writeGroup/final.vue'
import finalscore from './writeGroup/finalscore.vue'
import reply from './writeGroup/reply.vue'
import bindingMaterial from './writeGroup/bindingMaterial.vue'
import complete from './writeGroup/complete.vue'
export default {
  name: "write",
  components: {
    topicchoice,
    proposal,
    draft,
    final,
    finalscore,
    reply,
    complete,
    bindingMaterial
  },
  data() {
    return {
      formSwitch: {
        topicChoiceSwitch: 0, //论文选题开关（0关 1开）
        proposalSwitch: 0, //开题报告
        draftSwitch: 0, //初稿及修改
        finalSwitch: 0, //终稿
        finalScoreSwitch: 0, //终稿指导成绩
        replySwitch: 0, //答辩
        bindingMaterialSwitch: 0, //胶装材料
      },
      stepGroup: [], //答辩流程menu
      thesisRecord: {},
      active: 'topicchoice',
      configureVisible:true,
      permission: false

    };
  },
  created() {
     this.queryStudentIsCommitThesis()
  },
  mounted() {
    this.getMyApplyList()
  },
  methods: {
    queryStudentIsCommitThesis(){
      let param={}
      this.$store.dispatch("thesis/queryStudentIsCommitThesis", param).then((ret) => {
          if(ret.data){
             this.permission=true
          }else{
            this.permission=false
          }
      })
    },
    /* 提交记录审核记录 */
    getMyApplyList() {
      let param = {}
      this.$store.dispatch("thesis/getThesisCheckDetailByParam", param).then((ret) => {
        if (ret.code == 0) {
          this.getEfficientThesisBatch()
          this.thesisRecord = ret.data.thesisRecord
        } else {
          this.$message.error(ret.msg);
        }
      }).catch((err) => {
      });
    },
    getEfficientThesisBatch() { //菜单
      let param = {}
      this.$store.dispatch("thesis/getEfficientThesisBatch", param).then((ret) => {
        if (ret.code == 0) {
          //生效批次生成流程逐条判断
          let topicChoiceSwitch = ret.data.topicChoiceSwitch
          /* 选题 */
          if (topicChoiceSwitch == 1)
            if (this.thesisRecord.thesisStatus > 1) {
              this.stepGroup.push({
                lable: '选题',
                tag: 'topicchoice',
                active: 1, //0 未完成  1完成
                thesisStatus: 0
              })
            } else {
              this.stepGroup.push({
                lable: '选题',
                tag: 'topicchoice',
                active: 1, //0 未完成  1完成
                thesisStatus: 0
              })
            }
          //开题报告
          let proposalSwitch = ret.data.proposalSwitch
          console.log(this.thesisRecord.thesisStatus)
          if (proposalSwitch == 1) {
            if (this.thesisRecord.thesisStatus >= 2) {
              this.stepGroup.push({
                lable: '开题报告',
                tag: 'proposal',
                active: 1, //0 未完成  1完成
                thesisStatus: 1
              })
            } else {
              this.stepGroup.push({
                lable: '开题报告',
                tag: 'proposal',
                active: 0, //0 未完成  1完成
                thesisStatus: 1
              })
            }

          }
          //初稿修改
          let draftSwitch = ret.data.draftSwitch
          if (draftSwitch == 1) {
            if (this.thesisRecord.thesisStatus >= 3) {
              this.stepGroup.push({
                lable: '初稿及修改',
                tag: 'draft',
                active: 1, //0 未完成  1完成
                thesisStatus: 2
              })
            } else {
              this.stepGroup.push({
                lable: '初稿及修改',
                tag: 'draft',
                active: 0, //0 未完成  1完成
                thesisStatus: 2
              })
            }
          }
          //终稿
          let finalSwitch = ret.data.finalSwitch
          if (finalSwitch == 1) {
            if (this.thesisRecord.thesisStatus >= 4) {
              this.stepGroup.push({
                lable: '终稿',
                tag: 'final',
                active: 1, //0 未完成  1完成
                thesisStatus: 2
              })
            } else {
              this.stepGroup.push({
                lable: '终稿',
                tag: 'final',
                active: 0, //0 未完成  1完成
                thesisStatus: 2
              })
            }
          }
          //终稿指导成绩
          let finalScoreSwitch = ret.data.finalScoreSwitch
          if (finalScoreSwitch == 1) {
            if (this.thesisRecord.thesisStatus >= 5) {
              this.stepGroup.push({
                lable: '终稿指导成绩',
                tag: 'finalscore',
                active: 1, //0 未完成  1完成
                thesisStatus: 2
              })
            } else {
              this.stepGroup.push({
                lable: '终稿指导成绩',
                tag: 'finalscore',
                active: 0, //0 未完成  1完成
                thesisStatus: 2
              })
            }
          }
          //终稿指导成绩
          let replySwitch = ret.data.replySwitch
          if (replySwitch == 1) {
            if (this.thesisRecord.thesisStatus == 9) {
              this.stepGroup.push({
                lable: '答辩',
                tag: 'reply',
                active: 1, //0 未完成  1完成
                thesisStatus: 2
              })
            } else {
              this.stepGroup.push({
                lable: '答辩',
                tag: 'reply',
                active: 0, //0 未完成  1完成
                thesisStatus: 2
              })
            }
          }
          //胶装材料
          let bindingMaterialSwitch = ret.data.bindingMaterialSwitch
          if (bindingMaterialSwitch == 1) {
            if (this.thesisRecord.thesisStatus == 9) {
              this.stepGroup.push({
                lable: '胶装材料',
                tag: 'bindingMaterial',
                active: 1, //0 未完成  1完成
                thesisStatus: 2
              })
            } else {
              this.stepGroup.push({
                lable: '胶装材料',
                tag: 'bindingMaterial',
                active: 0, //0 未完成  1完成
                thesisStatus: 2
              })
            }
          }
          this.assemblyIndex(this.thesisRecord.thesisStatus,bindingMaterialSwitch);
        } else {
          this.$message.error(ret.msg);
        }
      }).catch((err) => {
      });
    },
    change(tag) {
      this.active = tag
    },
    assemblyIndex(thesisStatus,bindingMaterialSwitch) {
      if (thesisStatus == 1) {
        this.active = 'topicchoice'
      }
      if (thesisStatus == 2) {
        this.active = 'proposal'
      }
      if (thesisStatus == 3) {
        this.active = 'draft'
      }
      if (thesisStatus == 4) {
        this.active = 'final'
      }
      if (thesisStatus == 5) {
        this.active = 'finalscore'
      }
      if (thesisStatus == 9 && bindingMaterialSwitch == 0) {
        this.active = 'reply'
      }
      if (thesisStatus == 9 && bindingMaterialSwitch == 1) {
        this.active = 'complete'
      }
      if (thesisStatus == 10) {
        this.active = 'bindingMaterial'
      }
    }
  }
};
</script>
<style  lang="less">
@import '../../styles/base.less';

.ant-steps {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, .85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum", "tnum";
  display: flex;
  width: 100%;
  font-size: 0;
  text-align: left;
  text-align: initial;

  .ant-steps-item {
    position: relative;
    display: inline-block;
    flex: 1 1;
    vertical-align: top;
    cursor: pointer;
    height: 75px;
    .ant-steps-item-tail {
      position: absolute;
      top: 12px;
      left: 0;
      width: 71%;
      padding: 0 10px;
      margin-left: 28px;
      padding: 3.5px 24px;

      &:after {
        display: inline-block;
        width: 100%;
        height: 1px;
        background: rgba(0, 0, 0, .06);
        border-radius: 1px;
        transition: background .3s;
        content: "";
      }
    }

    .ant-steps-item-icon {
      width: 24px;
      height: 24px;
      margin: 0 8px 0 0;
      font-size: 12px;
      line-height: 24px;
      text-align: center;
      border-radius: 24px;
      background-color: #fff;
      border: 1px solid rgba(0, 0, 0, 0.25);

      .icon1 {
        color: rgba(0, 0, 0, .25);
      }

      .icon2 {
        color: rgba(0, 0, 0, .25);
      }
    }

    .ant-steps-item-content {
      width: 116px;
      margin-top: 8px;
      height: 55px;
      position: absolute;
      z-index: 999;
      left: 0px;
      top: 34px;
      font-size: 14px;
    }
  }

  .finish {
    .ant-steps-item-tail {
      &:after {
        background: #1890ff
      }
    }

    .ant-steps-item-icon {
      width: 26px;
      height: 26px;
      border: none;
      background: #1890ff;

      .icon1 {
        color: rgba(0, 0, 0, .25);
      }

      .icon2 {
        color: #fff;
      }
    }
  }

}

.tabbox {
  margin-top: 50px;
}
</style>


// WEBPACK FOOTER //
// src/pages/transactionPaper/write.vue